module.exports = __webpack_public_path__ + "img/IMG_9000_L_WoodMatted_MockedUp.cb43d87d.jpg";